import React, { useState, useEffect, useLayoutEffect } from 'react';
import PageHeader from '../PageHeader';
import { Table, Button, Skeleton, Card, Alert, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { axiosClient } from '../../apiClient';
import { mascaraCpf } from '../../functions/validation';

const { Link } = Typography;

export default function SellerListUser() {
  const navigate = useNavigate();
  const [listUsers, setListUsers] = useState([]);
  const [creditLimit, setCreditLimit] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosClient.get('/auth/list/seller-users-credit', { withCredentials: true }).then(({ data }) => {
      setListUsers(data.seller_users_list.map((obj, index) => ({ ...obj, key: index })));
      setCreditLimit(data.credit_limit);
      setLoading(false);
    });
  }, []);

  const useWindowSize = () => {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
    useLayoutEffect(() => {
      const updateSize = () => setSize([window.innerWidth, window.innerHeight]);
      window.addEventListener('resize', updateSize);
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  };

  const [width] = useWindowSize();

  const columns = width < 1100
    ? [{
        title: 'Descrição',
        render: (record) => (
          <>
            <Link>{record.nome}</Link>
            {record.cpf && <><br />{mascaraCpf(record.cpf)}</>}
            {record.email && <><br />{record.email}</>}
          </>
        ),
        ellipsis: true,
      }]
    : [
        {
          title: 'Nome',
          dataIndex: 'nome',
          width: '25%',
          render: (text, record) => <Link>{record.nome}</Link>,
          ellipsis: true,
        },
        {
          title: 'CPF/CNPJ',
          dataIndex: 'documento',
          render: (_, record) => record.cpf && mascaraCpf(record.cpf),
        },
        {
          title: 'Email',
          render: (_, record) => record.email,
        },
      ];

  if (loading) return <Skeleton active />;

  if (creditLimit === 0) {
    return (
      <Card>
        <Alert
          message="Você não possui representantes no seu plano. Contate a administração caso queira contratar esse serviço."
          type="info"
          showIcon
        />
      </Card>
    );
  }

  return (
    <>
      <PageHeader
        title="Representantes"
        subTitle={`${listUsers.length} de ${creditLimit}`}
        extra={
          <Button
            disabled={listUsers.length >= creditLimit}
            onClick={() => navigate(`/admin/configuracoes/representantes/cadastro`)}
            type="primary"
          >
            Adicionar
          </Button>
        }
      />
      <Table
        columns={columns}
        dataSource={listUsers}
        onRow={(record) => ({
          onClick: () => navigate(`/admin/configuracoes/representantes/cadastro/${record.id}`),
        })}
        style={{ cursor: 'pointer' }}
      />
    </>
  );
}
